// extracted by mini-css-extract-plugin
export default {"wrapper":"Mo","future":"No","title":"Oo","bullets":"Po","bullet":"Qo","button":"Ro"};
    if(module.hot) {
      // 1714442370178
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  